import React from "react";
import { PageHeader } from "../components/layout/PageHeader";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import AuditLog from "../components/settings/AuditLog";
import styles from "./Settings.module.css";

const ThemePreview = ({ name, active, onClick }) => {
  const swatchClass = name === "light" ? styles.swatchLight : styles.swatchDark;
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.themeCard} ${active ? styles.themeCardActive : ""}`}
      aria-pressed={active}
    >
      <div className={`${styles.swatch} ${swatchClass}`}>
        <div className={styles.swatchBar} />
        <div className={styles.swatchRow} />
        <div className={styles.swatchRowAlt} />
      </div>
      <div className={styles.themeLabel}>
        <span className={styles.themeName}>{name === "light" ? "Parchment (light)" : "Counsel (dark)"}</span>
        {active && <span className={styles.activeTag}>Active</span>}
      </div>
    </button>
  );
};

const Settings = () => {
  const { theme, setTheme } = useTheme();
  const { email, role, userInfo, logout } = useAuth();
  const isAdmin = role === "admin";

  return (
    <div>
      <PageHeader pageName="Settings" />
      <div className="main-page-content fade-in">
        <div className={styles.grid}>
          <section className="card">
            <header className={styles.sectionHead}>
              <h2 className={styles.sectionTitle}>Appearance</h2>
              <p className="muted">Choose how CMBSDLT looks on this device. Theme is remembered per browser.</p>
            </header>
            <div className={styles.themeRow}>
              <ThemePreview name="light" active={theme === "light"} onClick={() => setTheme("light")} />
              <ThemePreview name="dark"  active={theme === "dark"}  onClick={() => setTheme("dark")} />
            </div>
          </section>

          <section className="card">
            <header className={styles.sectionHead}>
              <h2 className={styles.sectionTitle}>Account</h2>
              <p className="muted">Your profile and access level.</p>
            </header>
            <dl className={styles.kv}>
              <div><dt>Email</dt><dd>{email || "—"}</dd></div>
              <div><dt>Role</dt><dd className={styles.role}>{role || "user"}</dd></div>
              {userInfo?.publicAddress && (
                <div><dt>Wallet</dt><dd className="mono">{userInfo.publicAddress}</dd></div>
              )}
              {userInfo?.issuer && (
                <div><dt>Issuer</dt><dd className="mono">{userInfo.issuer}</dd></div>
              )}
            </dl>
            <div className={styles.actions}>
              <button className="btn btn-ghost" onClick={logout}>
                <i className="bi bi-box-arrow-right" /> Sign out
              </button>
            </div>
          </section>

          <section className="card">
            <header className={styles.sectionHead}>
              <h2 className={styles.sectionTitle}>About this workspace</h2>
              <p className="muted">CMBSDLT &mdash; commercial mortgage-backed securities, distributed-ledger noteholder platform.</p>
            </header>
            <ul className={styles.bullets}>
              <li>Data shown is filtered to your organization&apos;s holder identity.</li>
              <li>Audit-grade history is preserved for every note edit.</li>
              <li>For support, contact your firm administrator.</li>
            </ul>
          </section>
        </div>

        <div style={{ marginTop: 18 }}>
          <AuditLog />
        </div>

        {!isAdmin && (
          <p className="muted" style={{ marginTop: 10, fontSize: 12 }}>
            You see audit entries for notes owned by your organization. Firm-wide entries are visible to administrators.
          </p>
        )}
      </div>
    </div>
  );
};

export default Settings;
